import { render, staticRenderFns } from "./AcceptCookies.vue?vue&type=template&id=63e2d5ca&"
import script from "./AcceptCookies.vue?vue&type=script&lang=js&"
export * from "./AcceptCookies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports